import { RefObject, useEffect, useState } from 'react'

export function useAnimatedRender(
  show: boolean,
  toAnimateRef: RefObject<unknown>
) {
  const [shouldRender, setRender] = useState(show)

  useEffect(() => {
    if (show) {
      setRender(true)
    }
  }, [show])

  function onAnimationEnd(e: React.AnimationEvent): void {
    if (e.target === toAnimateRef.current) {
      if (!show) {
        setRender(false)
      }
    }
  }

  return [shouldRender, onAnimationEnd] as const
}

export const defaultAnimation = `
animation: fadeOut 0.3s;

&.element-in {
  animation: fadeIn 0.3s;
}

@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@keyframes fadeOut {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
`
